import {
  extensionViewOf,
  formatFlag,
  formatReference,
  formatText,
  productExtensionStateOf,
  type ExtensionSpec,
  type ExtensionView,
  type ProductExtensionEnvelope,
  type ProductExtensionState,
} from '@krp/client-runtime'

import { OWN_EXTENSION_KIND, ownProductExtension } from '../api/productExtensionApi'

/** Что показываем из расширения карточки своей базы по версиям схемы (RP-FB71, 3.2): полное наименование, группа, маркировка. */
export const OWN_EXTENSION_SPEC: ExtensionSpec = {
  versions: {
    1: [
      { id: 'fullName', label: 'Полное наименование', inSummary: true, format: formatText },
      { id: 'groupId', label: 'Группа', inSummary: true, format: formatReference('в группе', 'вне групп') },
      { id: 'isMarked', label: 'Маркировка', inSummary: true, format: formatFlag('маркируемый', 'не маркируется') },
    ],
  },
}

/** Вид расширения карточки своей базы: чистая функция, без запроса. */
export const ownExtensionViewOf = (envelope: ProductExtensionEnvelope): ExtensionView => extensionViewOf(envelope, OWN_EXTENSION_SPEC)

/** Читает расширение карточки у службы своей базы и отдаёт готовый вид. */
export function useOwnProductExtension(resourceId: string, remoteKey: string): ProductExtensionState {
  const result = ownProductExtension.useQuery({ resourceId, productId: remoteKey })
  return productExtensionStateOf(result, OWN_EXTENSION_SPEC)
}

/** Описание вида «Собственная» для реестра источников товара (composition): только то, что знает пакет вида. */
export const ownProductExtensionSource = {
  kind: OWN_EXTENSION_KIND,
  useExtension: useOwnProductExtension,
} as const
